var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankNull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    fillRule: "evenodd",
    d: "M20 .19c-.64 0-1.27.18-1.81.51L1.3 11.76a2.72 2.72 0 0 0-1.1 3.32 3.07 3.07 0 0 0 2.91 1.87H36.9c1.34 0 2.46-.75 2.91-1.87.46-1.17.1-2.53-1.1-3.32L21.8.7A3.43 3.43 0 0 0 20 .2ZM0 33.93c0-1.71 1.63-2.54 2.86-2.54H3v-9.32a1.43 1.43 0 0 1 1.42-1.43H9.2a1.43 1.43 0 0 1 1.43 1.43v9.17l-.01.15h5.6l-.02-.15v-9.17a1.43 1.43 0 0 1 1.43-1.43h4.76a1.43 1.43 0 0 1 1.43 1.43v9.17l-.01.15h5.6l-.02-.15v-9.17a1.43 1.43 0 0 1 1.43-1.43h4.76a1.43 1.43 0 0 1 1.42 1.43v9.32h.15c1.23 0 2.86.83 2.86 2.55v3.33c0 1.72-1.63 2.54-2.86 2.54H2.86C1.63 39.81 0 39 0 37.27v-3.34Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankNull);
export default ForwardRef;